module.exports = __webpack_public_path__ + "static/media/skill1_neg_en.4e273b8f.txt";